// export const backendlink = "https://poc.ausculto.com.hk";
// export const backendlink = "https://vitomeintegratedportal.azurewebsites.net/";
// export const backendlink = "http://localhost:7777/"
export const SITEKEY = "6LcEx3QrAAAAANEhDUec8fgFBVRjAbcU_mElNzpo";
// export const backendlink = "https://rhythm-integratedportalbackend.azurewebsites.net/"

// frontend use nginx proxy pass to backend, so this is call the nginx
// export const backendlink = process.env.BACKENDLINK;
export const backendlink = "https://portalbackend-k8s.vitome.com/";